export default {
    getOrdersPosition: ({ordersPosition}) => ordersPosition,
    // getOrdersOpen: ({orders}) => ordersOpen,
    // getOrdersHistory: ({orders}) => ordersHistory
  };